import { sendButtonClick } from '@/services/tracking'
import { useGlobalStore } from '@/stores/global'
import type { DirectiveBinding } from 'vue'

export default {
  mounted(el: HTMLElement, binding: DirectiveBinding<string>) {
    const globalStore = useGlobalStore()

    const id = binding.value
    if (!id) {
      console.warn('v-track: missing ID')
      return
    }

    el.setAttribute('data-track-id', id)

    el.addEventListener('click', () => {
      sendButtonClick(id, globalStore.currentVisitId as number)
    })
  }
}
